export default {
  namespaced: true,
  state: {
    notifications: [],
    hasError: false,
    hasSnackbar: false
  },
  mutations: {
    ADD_NOTIFICATION(state, notification) {
      const newNotification = {
        id: Date.now() + Math.random(),
        message: notification.message,
        type: notification.type || 'info',
        timeout: notification.timeout || 5000,
        timestamp: new Date()
      }
      state.notifications.push(newNotification)
      
      if (notification.type === 'error') {
        state.hasError = true
      }
      state.hasSnackbar = true
    },
    REMOVE_NOTIFICATION(state, id) {
      state.notifications = state.notifications.filter(n => n.id !== id)
      state.hasSnackbar = state.notifications.length > 0
      state.hasError = state.notifications.some(n => n.type === 'error')
    },
    CLEAR_ALL_NOTIFICATIONS(state) {
      state.notifications = []
      state.hasError = false
      state.hasSnackbar = false
    },
    CLEAR_NOTIFICATIONS(state) {
      state.notifications = []
      state.hasError = false
      state.hasSnackbar = false
    }
  },
  actions: {
    add({ commit }, notification) {
      commit('ADD_NOTIFICATION', notification)
    },
    remove({ commit }, id) {
      commit('REMOVE_NOTIFICATION', id)
    },
    clearAll({ commit }) {
      commit('CLEAR_ALL_NOTIFICATIONS')
    }
  },
  getters: {
    notifications: state => state.notifications,
    hasError: state => state.hasError,
    hasSnackbar: state => state.hasSnackbar,
    errorNotifications: state => state.notifications.filter(n => n.type === 'error'),
    successNotifications: state => state.notifications.filter(n => n.type === 'success'),
    count: state => state.notifications.length
  }
}
